import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "./assets/logo2.png"; 

const scrollToTop = () => {
  setTimeout(() => {
    window.scrollTo({ top: 670, behavior: "smooth" });
  }, 100); // wait for route change
};

const scrollToTop1 = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const Navbar = () => (
  <nav className="navbar">
    <div className="navbar__logo">
      {" "}
      <Link className="navbarlogo" to="/" onClick={scrollToTop1}>
        <img
          src={logo}
          alt="Logo"
          className="navbar__logo-image"
        />
      </Link>
    </div>
    <ul className="navbar__links">
      <li>
        <Link className="navbarlinks" to="/About" onClick={scrollToTop1}>
          About Us
        </Link>
      </li>
      <li>
        <Link className="navbarlinks" to="/" onClick={scrollToTop}>
          Categories
        </Link>
      </li>
      <li>
        <Link className="navbarlinks" to="/ContactUs" onClick={scrollToTop1}>
          Contact Us
        </Link>
      </li>
    </ul>
  </nav>
);

export default Navbar;
